/**
*  Copyright (c) 2022 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonConstants } from './../../../../../app/common/constants/common-constants';
import { KbaCommentCreateInfo, KbaComments } from '../knowledgebasecontainer/knowledgebasedetail/kbacomments/kbacomments';

@Injectable({
  providedIn: 'root'
})
export class KbacommentsService {

  constructor(public http: HttpClient) {}


  // List of Comments
  public getKbaComments(kbaId: number): Observable<KbaComments> {
    return this.http.get<KbaComments>(CommonConstants.SERVICE_VERSION_PATH_V1 + `/customer/kbas/${kbaId}/comments`);
  }

  // Add Comments
public addComment(kbaId: number, kbaCommentCreateInfo: KbaCommentCreateInfo) {
    return this.http.post(CommonConstants.SERVICE_VERSION_PATH_V1 + `/customer/kbas/${kbaId}/comments`, kbaCommentCreateInfo);
  }


}
